module.exports = __webpack_public_path__ + "imgs/02140c3a61fb6855ec3ce038fe5ef674.jpg";